import classNames from "classnames";
import { inject, observer } from "mobx-react";
import React from "react";
import { UpgradeButton } from "@fidget/common/components/button/upgradeButton";
import { IUiStore } from "../../models/ui/UiStore";
import { L10nHtml } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "./chatLimit.css";

interface Props {
  hidden?: boolean;
  uiStore?: IUiStore;
}

@inject("uiStore")
@observer
export class ChatLimit extends React.Component<Props, {}> {
  render() {
    return (
      <div className={classNames(styles.container, { [styles.hidden]: this.props.hidden })}>
        <p className={styles.text}>
          <L10nHtml id={"plan.upgrade.history"} />
        </p>
        <UpgradeButton
          text={intl.formatMessage("plan.upgrade.chat.cta")}
          whiteStyle
          onClick={this.props.uiStore!.changeUpgrade}
        />
      </div>
    );
  }
}
